/* eslint-disable import/order */
// common
import download from '@slicing/img/icons/download.svg';
import exit from '@slicing/img/icons/exit.svg';
import guard from '@slicing/img/icons/guard.svg';
import logo from '@slicing/img/logo.png';
import logoWithText from '@slicing/img/logo-with-text.png';
import minusGray from '@slicing/img/icons/minus-gray.svg';
import minusGreen from '@slicing/img/icons/minus-green.svg';
import moreDots from '@slicing/img/icons/more-dots.svg';
import notifications from '@slicing/img/icons/notifications.svg';
import plusGray from '@slicing/img/icons/plus-gray.svg';
import plusGreen from '@slicing/img/icons/plus-green.svg';
import trashRed from '@slicing/img/icons/trash-red.svg';
import trashRedBig from '@slicing/img/icons/trash-red-big.svg';
import userAdd from '@slicing/img/icons/user-add.svg';
import userGreen from '@slicing/img/icons/user-green.svg';
import successGreen from '@slicing/img/icons/success-green.svg';
import errorRed from '@slicing/img/icons/error-red.svg';
import noDataImage from '@slicing/img/no-data-image.svg';
import linkIcon from '@slicing/img/icons/link-icon.svg';

// admin panel
import addColumn from '@slicing/img/icons/add-column.svg';
import addGroup from '@slicing/img/icons/add-group.svg';
import addGroupManagement from '@slicing/img/icons/add-group-white.svg';
import addRule from '@slicing/img/icons/add-rule.svg';
import addSiteWhite from '@slicing/img/icons/add-site-white.svg';
import arrow from '@slicing/img/icons/arrow.svg';
import arrowBackGreen from '@slicing/img/icons/arrow-back-green.svg';
import arrowLeftGreen from '@slicing/img/icons/arrow-left-green.svg';
import arrowRightWhite from '@slicing/img/icons/arrow-right-white.svg';
import cross from '@slicing/img/icons/cross.svg';
import crossAround from '@slicing/img/icons/cross-around.svg';
import crossGreenBig from '@slicing/img/icons/cross-green-big.svg';
import crossRed from '@slicing/img/icons/cross-red.svg';
import crossRedBig from '@slicing/img/icons/cross-red-big.svg';
import disableGreen from '@slicing/img/icons/disable-green.svg';
import enableUserGreen from '@slicing/img/icons/enable-user-green.svg';
import eye from '@slicing/img/icons/eye.svg';
import eyeActive from '@slicing/img/icons/eye-active.svg';
import lock from '@slicing/img/icons/lock.svg';
import lockRed from '@slicing/img/icons/lock-red.svg';
import lockRedBig from '@slicing/img/icons/lock-red-big.svg';
import emailNotVerified from '@slicing/img/icons/email-not-verified.svg';
import invitationPending from '@slicing/img/icons/invitation-pending.svg';
import loginGreen from '@slicing/img/icons/login-green.svg';
import groupUsers from '@slicing/img/icons/group-users.svg';
import ungroupUsers from '@slicing/img/icons/ungroup-users.svg';

// dashboard
import arrowLeftGraySmall from '@slicing/img/icons/arrow-left-gray-small.svg';
import arrowLeftGreenSmall from '@slicing/img/icons/arrow-left-green-small.svg';
import arrowDownPurple from '@slicing/img/icons/arrow-down-purple.svg';
import arrowDownGray from '@slicing/img/icons/arrow-down-gray.svg';
import arrowDownGreen from '@slicing/img/icons/arrow-down-green.svg';
import arrowPurpleUp from '@slicing/img/icons/arrow-purple-up.svg';
import arrowRightGreen from '@slicing/img/icons/arrow-right-green.svg';
import arrowRightGreenSmall from '@slicing/img/icons/arrow-right-green-small.svg';
import arrowUpGray from '@slicing/img/icons/arrow-up-gray.svg';
import arrowUpGreen from '@slicing/img/icons/arrow-up-green.svg';
import calendarArrowLeftGreen from '@slicing/img/icons/calendar-arrow-left-green.svg';
import calendarArrowRightGreen from '@slicing/img/icons/calendar-arrow-right-green.svg';
import calendarGray from '@slicing/img/icons/calendar-gray.svg';
import calendarGreen from '@slicing/img/icons/calendar-green.svg';
import calendarToday from '@slicing/img/icons/calendar-today.svg';
import calendarPurple from '@slicing/img/icons/calendar-purple.svg';
import calendarWhiteAdd from '@slicing/img/icons/calendar-white-add.svg';
import calendarWhiteSmall from '@slicing/img/icons/calendar-white-small.svg';
import cameraGreenSmall from '@slicing/img/icons/camera-green-small.svg';
import cameraWhiteSmall from '@slicing/img/icons/camera-white-small.svg';
import cancerIconGrey from '@slicing/img/icons/cancer-ico-grey.svg';
import cancerIconPurple from '@slicing/img/icons/cancer-ico-purple.svg';
import chartGreen from '@slicing/img/icons/chart-green.svg';
import check from '@slicing/img/icons/check.svg';
import checkWhite from '@slicing/img/icons/check-white.svg';
import checkWhiteSmall from '@slicing/img/icons/check-white-small.svg';
import crossGreenSmall from '@slicing/img/icons/cross-green-small.svg';
import crossWhite from '@slicing/img/icons/cross-white.svg';
import duplicateGreen from '@slicing/img/icons/duplicate-green.svg';
import familyBuilder from '@slicing/img/icons/family-build.svg';
import filter from '@slicing/img/icons/filter.svg';
import filterClose from '@slicing/img/icons/filter-close.svg';
import inviteGreen from '@slicing/img/icons/invite-green.svg';
import inviteWhite from '@slicing/img/icons/invite-white.svg';
import inviteWhiteSmall from '@slicing/img/icons/invite-white-small.svg';
import invite from '@slicing/img/icons/invite.svg';
import launch from '@slicing/img/icons/launch.svg';
import lockWhiteSmall from '@slicing/img/icons/lock-white-small.svg';
import logFile from '@slicing/img/icons/log-file.svg';
import medIconGrey from '@slicing/img/icons/med-ico-grey.svg';
import medIconPurple from '@slicing/img/icons/med-ico-purple.svg';
import navbarCalendar from '@slicing/img/icons/navbar-ico-2.svg';
import navbarCalendarActive from '@slicing/img/icons/navbar-ico-2-active.svg';
import navbarPatients from '@slicing/img/icons/navbar-ico-1.svg';
import navbarPatientsActive from '@slicing/img/icons/navbar-ico-1-active.svg';
import navbarReports from '@slicing/img/icons/navbar-ico-4.svg';
import navbarReportsActive from '@slicing/img/icons/navbar-ico-4-active.svg';
import navbarSpreadsheets from '@slicing/img/icons/navbar-ico-5.svg';
import navbarSpreadsheetsActive from '@slicing/img/icons/navbar-ico-5-active.svg';
import navbarTesting from '@slicing/img/icons/navbar-ico-3.svg';
import navbarTestingActive from '@slicing/img/icons/navbar-ico-3-active.svg';
import note from '@slicing/img/icons/note.svg';
import noteCallGreen from '@slicing/img/icons/note-call-green.svg';
import noteCallWhite from '@slicing/img/icons/note-call-white.svg';
import noteEmailGreen from '@slicing/img/icons/note-email-green.svg';
import noteEmailWhite from '@slicing/img/icons/note-email-white.svg';
import noteRegularGreen from '@slicing/img/icons/note-regular-green.svg';
import noteRegularWhite from '@slicing/img/icons/note-regular-white.svg';
import noteWhiteSmall from '@slicing/img/icons/note-white-small.svg';
import numbers123 from '@slicing/img/icons/numbers-123.svg';
import openPatientRecord from '@slicing/img/icons/open-patient-record.svg';
import patientIconGrey from '@slicing/img/icons/patient-ico-grey.svg';
import patientIconPurple from '@slicing/img/icons/patient-ico-purple.svg';
import pedigreeNextItem from '@slicing/img/icons/pedigree-next-ico.svg';
import pencil2Green from '@slicing/img/icons/pencil2-green.svg';
import pencilGreen from '@slicing/img/icons/pencil-green.svg';
import pencilWhite from '@slicing/img/icons/pencil-white.svg';
import personWithArrow from '@slicing/img/icons/person-with-arrow.svg';
import plus from '@slicing/img/icons/plus.svg';
import queryBuilderHeaderIcon from '@slicing/img/icons/query-builder-header-ico.svg';
import redo from '@slicing/img/icons/redo.svg';
import reminder from '@slicing/img/icons/reminder.svg';
import remindWhiteSmall from '@slicing/img/icons/remind-white-small.svg';
import report from '@slicing/img/icons/report.svg';
import reportBig from '@slicing/img/icons/report-big.svg';
import reportWhiteSmall from '@slicing/img/icons/report-white-small.svg';
import riskGreen from '@slicing/img/icons/risk-green.svg';
import riskPurple from '@slicing/img/icons/risk-purple.svg';
import riskWhiteSmall from '@slicing/img/icons/risk-white-small.svg';
import rocket from '@slicing/img/icons/rocket.svg';
import search from '@slicing/img/icons/search.svg';
import settingsUrl from '@slicing/img/icons/pedigree-node-settings.svg';
import shared from '@slicing/img/icons/shared.svg';
import shareGreen from '@slicing/img/icons/share-green.svg';
import shareGreenOff from '@slicing/img/icons/share-green-off.svg';
import shareOrchid from '@slicing/img/icons/share-orchid.svg';
import sharePurple from '@slicing/img/icons/share-purple.svg';
import showAllGreen from '@slicing/img/icons/show-all-green.svg';
import sortArrowDown from '@slicing/img/icons/sort-arrow-down.svg';
import sortArrowUp from '@slicing/img/icons/sort-arrow-up.svg';
import spreadsheetAddWhite from '@slicing/img/icons/spreadsheet-add-white.svg';
import templateAddWhite from '@slicing/img/icons/template-add-white.svg';
import testingGreen from '@slicing/img/icons/testing-green.svg';
import testingWhiteSmall from '@slicing/img/icons/testing-white-small.svg';
import textT from '@slicing/img/icons/text-t.svg';
import undo from '@slicing/img/icons/undo.svg';
import undoGreen from '@slicing/img/icons/undo-green.svg';
import user from '@slicing/img/icons/user.svg';
import userWhiteSmall from '@slicing/img/icons/user-white-small.svg';
import viewBlock from '@slicing/img/icons/view-block.svg';
import viewBlockActive from '@slicing/img/icons/view-block-active.svg';
import viewLine from '@slicing/img/icons/view-line.svg';
import viewLineActive from '@slicing/img/icons/view-line-active.svg';
import warning from '@slicing/img/icons/warning.svg';
import warningCircleYellow from '@slicing/img/icons/warning-circle-yellow.svg';
import warningGray from '@slicing/img/icons/warning-gray.svg';
import warningGreen from '@slicing/img/icons/warning-green.svg';
import warningYellow from '@slicing/img/icons/warning-yellow.svg';
import warningTriangleGreen from '@slicing/img/icons/warning-triangle-green.svg';
import warningTriangleWhite from '@slicing/img/icons/warning-triangle-white.svg';

// cancers
import brain from '@slicing/img/icons/cancers/brain.svg';
import breast from '@slicing/img/icons/cancers/breast.svg';
import lung from '@slicing/img/icons/cancers/lung.svg';
import ovary from '@slicing/img/icons/cancers/ovary.svg';
import pancreas from '@slicing/img/icons/cancers/pancreas.svg';
import thyroid from '@slicing/img/icons/cancers/thyroid.svg';

// fhq
import clinicLogo from '@slicing/img/clinic-logo.svg';
import defaultLogoRAQ from '@slicing/img/default-logo-raq.svg';
import questionMark from '@slicing/img/icons/question-mark.svg';
import menuButton from '@slicing/img/icons/menu-button.svg';
import pencilPurple from '@slicing/img/icons/pencil-purple.svg';
import crossGray from '@slicing/img/icons/cross-gray.svg';
import userIco from '@slicing/img/icons/user-ico.svg';

// wysiwyg
import wysiwygIconLink from '@slicing/img/icons/wysiwyg-icon-link.svg';

const cancers: { [key: string]: string } = {
  brain,
  breast,
  lung,
  ovary,
  pancreas,
  thyroid,
};

export {
  addColumn,
  addGroup,
  addGroupManagement,
  addRule,
  addSiteWhite,
  arrow,
  arrowBackGreen,
  arrowDownGray,
  arrowDownGreen,
  arrowDownPurple,
  arrowLeftGraySmall,
  arrowLeftGreen,
  arrowLeftGreenSmall,
  arrowPurpleUp,
  arrowRightGreen,
  arrowRightGreenSmall,
  arrowRightWhite,
  arrowUpGray,
  arrowUpGreen,
  calendarArrowLeftGreen,
  calendarArrowRightGreen,
  calendarGray,
  calendarGreen,
  calendarPurple,
  calendarToday,
  calendarWhiteAdd,
  calendarWhiteSmall,
  cameraGreenSmall,
  cameraWhiteSmall,
  cancerIconGrey,
  cancerIconPurple,
  cancers,
  chartGreen,
  check,
  checkWhite,
  checkWhiteSmall,
  clinicLogo,
  cross,
  crossAround,
  crossGray,
  crossGreenBig,
  crossGreenSmall,
  crossRed,
  crossRedBig,
  crossWhite,
  defaultLogoRAQ,
  disableGreen,
  download,
  duplicateGreen,
  emailNotVerified,
  enableUserGreen,
  errorRed,
  exit,
  eye,
  eyeActive,
  familyBuilder,
  filter,
  filterClose,
  groupUsers,
  guard,
  invitationPending,
  invite,
  inviteGreen,
  inviteWhite,
  inviteWhiteSmall,
  launch,
  lock,
  lockRed,
  lockRedBig,
  lockWhiteSmall,
  logFile,
  loginGreen,
  logo,
  logoWithText,
  medIconGrey,
  medIconPurple,
  menuButton,
  minusGray,
  minusGreen,
  moreDots,
  navbarCalendar,
  navbarCalendarActive,
  navbarPatients,
  navbarPatientsActive,
  navbarReports,
  navbarReportsActive,
  navbarSpreadsheets,
  navbarSpreadsheetsActive,
  navbarTesting,
  navbarTestingActive,
  noDataImage,
  note,
  noteCallGreen,
  noteCallWhite,
  noteEmailGreen,
  noteEmailWhite,
  noteRegularGreen,
  noteRegularWhite,
  noteWhiteSmall,
  notifications,
  numbers123,
  openPatientRecord,
  patientIconGrey,
  patientIconPurple,
  pedigreeNextItem,
  pencil2Green,
  pencilGreen,
  pencilPurple,
  pencilWhite,
  personWithArrow,
  plus,
  plusGray,
  plusGreen,
  queryBuilderHeaderIcon,
  questionMark,
  redo,
  reminder,
  remindWhiteSmall,
  report,
  reportBig,
  reportWhiteSmall,
  riskGreen,
  riskPurple,
  riskWhiteSmall,
  rocket,
  search,
  settingsUrl,
  shared,
  shareGreen,
  shareGreenOff,
  shareOrchid,
  sharePurple,
  showAllGreen,
  sortArrowDown,
  sortArrowUp,
  spreadsheetAddWhite,
  successGreen,
  templateAddWhite,
  testingGreen,
  testingWhiteSmall,
  textT,
  trashRed,
  trashRedBig,
  undo,
  undoGreen,
  ungroupUsers,
  user,
  userAdd,
  userGreen,
  userWhiteSmall,
  viewBlock,
  viewBlockActive,
  viewLine,
  viewLineActive,
  warning,
  warningCircleYellow,
  warningGray,
  warningGreen,
  warningTriangleGreen,
  warningTriangleWhite,
  warningYellow,
  wysiwygIconLink,
  userIco,
  linkIcon,
};
